import { Injectable } from '@angular/core'
import { PvsRequestFactoryService } from './pvs-request-factory.service'
import { ApiPath } from '../../config/global-const'
import { SharedService } from './shared.service'
import _ from 'lodash'

export interface IRedeemInfo {
    code: string
    amt: null
    note?: string
}
export interface ITurnInfo {
    id?: number
    workingDate?: string
    type: string
    turnOrderNo: number
    amt: number
    tip: number
    paidInCashAmt: number
    redeemAmt: number
    redeems: Array<any>
    paymentStatus: string
    isClientRequested: boolean
    note?: string
    histories?: Array<any>
    optionalData?: any
    updatedAt?: string
}

export interface ITurnColumn {
    id?: number
    salonId?: number
    workingDate: string
    employeeId: number
    employee: any
    orderNo: number
    turns: Array<ITurnInfo>
    turnCnt?: number
    totalAmt?: number
    totalAmtInCash?: number
    totalTip?: number
}

export interface IWorkingDate {
    id?: number
    salonId?: number
    workingDate: string
    employees: Array<ITurnColumn>
    isLocked?: boolean
    totalAmt: number
    totalAmtInCash: number
    totalTip: number
    actuallyCash: number
    actuallyCashHistories: Array<any>
    note: number
    noteHistories: Array<any>
    summary?: any
}

@Injectable({
    providedIn: 'root',
})
export class WorkingService {
    constructor(private requestService: PvsRequestFactoryService, private sharedService: SharedService) {}

    public getData(workingDate: string) {
        const url = this.requestService.createUrl(ApiPath.WORKING.PATH)
        return this.requestService.requestGet(url, { date: workingDate })
    }
    public addNewEmployee(workingDate: string, employeeId: number) {
        const url = this.requestService.createUrl(ApiPath.WORKING.ADD_EMPLOYEE.PATH)
        return this.requestService.requestPost(url, {
            workingDate: workingDate,
            employeeId: employeeId,
        })
    }
    public reorderEmployees(workingDate: string, employeeList: Array<number>) {
        const url = this.requestService.createUrl(ApiPath.WORKING.REORDER_EMPLOYEES.PATH)
        return this.requestService.requestPost(url, {
            workingDate: workingDate,
            employeeList: employeeList,
        })
    }
    public removeEmployee(workingDate: string, employeeId: number) {
        const url = this.requestService.createUrl(ApiPath.WORKING.REMOVE_EMPLOYEE.PATH)
        return this.requestService.requestPost(url, {
            workingDate: workingDate,
            employeeId: employeeId,
        })
    }
    public addTurn(workingDate: string, employeeId: number, turnInfo: ITurnInfo) {
        const url = this.requestService.createUrl(ApiPath.WORKING.ADD_TURN.PATH)
        return this.requestService.requestPost(url, {
            workingDate: workingDate,
            employeeId: employeeId,
            type: turnInfo.type,
            amt: turnInfo.amt,
            tip: turnInfo.tip,
            paidInCashAmt: turnInfo.paidInCashAmt,
            redeemAmt: turnInfo.redeemAmt,
            redeems: turnInfo.redeems,
            paymentStatus: turnInfo.paymentStatus,
            isClientRequested: turnInfo.isClientRequested,
            note: turnInfo.note,
        })
    }
    public updateTurn(turnId: number, turnInfo: ITurnInfo) {
        const url = this.requestService.createUrl(ApiPath.WORKING.UPDATE_TURN.PATH)
        return this.requestService.requestPut(url, {
            id: turnId,
            workingDate: turnInfo.workingDate,
            type: turnInfo.type,
            amt: turnInfo.amt,
            tip: turnInfo.tip,
            paidInCashAmt: turnInfo.paidInCashAmt,
            redeemAmt: turnInfo.redeemAmt,
            redeems: turnInfo.redeems,
            paymentStatus: turnInfo.paymentStatus,
            isClientRequested: turnInfo.isClientRequested,
            note: turnInfo.note,
        })
    }
    public deleteTurn(turnId: number) {
        const url = this.requestService.createUrl(ApiPath.WORKING.DELETE_TURN.PATH, { turnId: turnId })
        return this.requestService.requestDelete(url)
    }
    public calcTurnCnt(turns: Array<ITurnInfo>) {
        const sorted = _.sortBy(turns, 'turnOrderNo')
        const MIN_SERVICE = 27
        let turnCnt = 0
        // let requestedCnt = 0
        let bonusAmt = 0
        for (const i of sorted) {
            if (i.type === 'crying') {
                continue
            }
            if (!i.amt) {
                // empty service
                continue
            }
            // "bonus" service
            if (i.amt < MIN_SERVICE) {
                bonusAmt += i.amt
                if (bonusAmt >= MIN_SERVICE) {
                    turnCnt += 1
                    bonusAmt = 0
                }
                continue
            }
            if (i.isClientRequested) {
                turnCnt += 0.5
            } else {
                // normal service
                turnCnt += 1
            }
            // reset bonus
            bonusAmt = 0
        }
        // calc crying turns
        turnCnt += sorted.filter((e) => e.type === 'crying')?.length || 0
        // // calc requested
        // turnCnt -= requestedCnt / 2
        return Math.ceil(turnCnt)
        // return turnCnt
    }
    public calcTotalAmt(turns: Array<ITurnInfo>) {
        const total = turns.reduce((previousValue, currentValue) => previousValue + currentValue.amt, 0)
        return Math.round(total * 100) / 100
    }
    public calcTotalTip(turns: Array<ITurnInfo>) {
        const total = turns.reduce((previousValue, currentValue) => previousValue + currentValue.tip, 0)
        return Math.round(total * 100) / 100
    }
    public updateActuallyCash(workingDate: string, amt: number) {
        const url = this.requestService.createUrl(ApiPath.WORKING.ACTUALLY_CASH.PATH)
        return this.requestService.requestPut(url, { workingDate: workingDate, amt: amt })
    }
    public updateNote(workingDate: string, note: string) {
        const url = this.requestService.createUrl(ApiPath.WORKING.NOTE.PATH)
        return this.requestService.requestPut(url, { workingDate: workingDate, note: note })
    }
    public updateMultipleTips(workingDate: string, turns: Array<any>, markDone: boolean) {
        const url = this.requestService.createUrl(ApiPath.WORKING.UPDATE_MULTIPLE_TIPS.PATH)
        return this.requestService.requestPut(url, {
            workingDate: workingDate,
            turns: turns,
            markDone: markDone,
        })
    }
}
